module.exports = __webpack_public_path__ + "img/banner-1.4af47994.jpg";